(function handleProductView() {
  const storage = localStorage.getItem('recently-viewed');
  const store = storage !== null ? JSON.parse(storage) : {};
  const current = JSON.parse(document.querySelector('[data-product-card-json]')?.textContent || '{}');

  const key = Object.keys(current)[0];

  if (Object.keys(store).length > 7) {
    delete store[Object.keys(store)[0]];
  }

  store[key] = current[key];

  localStorage.setItem('recently-viewed', JSON.stringify(store));
})();
